import React from 'react';
import { AggregatorConfigItem } from './AggregatorConfigItem';
import { Button } from 'react-bootstrap';
import { observer } from 'mobx-react';

const sortFn = (aName, bName) => {
  if (aName.unsaved) {
    return 1;
  }
  if (bName.unsaved) {
    return -1;
  }
  const a = aName.propertyName.toUpperCase();
  const b = bName.propertyName.toUpperCase();
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
}

export const AggregatorConfigItems = observer(({ items, rules, addCustomItem, addDefinedItem, hasBlankItem, updateConfigItem, deleteConfigItem, propertyNames, customPropertyNames, canEdit }) => {
  const customItems = items.filter(item => item.isCustomProperty).sort(sortFn);
  const definedItems = items.filter(item => !item.isCustomProperty).sort(sortFn);
  return (
    <div>
      <h3>Items</h3>
      {
        definedItems.map((item, index) => <AggregatorConfigItem key={index} item={item} rules={rules} updateConfigItem={updateConfigItem} deleteConfigItem={deleteConfigItem} propertyNames={propertyNames} canEdit={canEdit} />)
      }
      <Button onClick={addDefinedItem} disabled={hasBlankItem}>Add Item</Button>
      <h3>Custom Items</h3>
      {
        customItems.map((item, index) => <AggregatorConfigItem key={index} item={item} rules={rules} updateConfigItem={updateConfigItem} deleteConfigItem={deleteConfigItem} propertyNames={customPropertyNames} canEdit={canEdit}/>)
      }
      <Button onClick={addCustomItem} disabled={hasBlankItem}>Add Custom Item</Button>
    </div>
  );
});